import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { SelectArrayInput, TextInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import KeyValueInput from '../../../../Common/Utils/KeyValueInput';
import PropertyVisibilities from '../../../../StaticData/PropertyVisibilities';

const styles = createStyles({
  fields: {
    width: '90%'
  }
});

type Props = {
  classes: any
};

const SettingsTab = (props: Props) => (
  <div>
    <div style={{ display: 'flex', width: '90%' }}>
      <div style={{ flex: '1' }}>
        <Field name="name" source="name" component={TextInput} label="Name" className={props.classes.fields} /><br />
      </div>
      <div style={{ flex: '2' }}>
        <Field name="value" source="value" component={TextInput} label="Value" className={props.classes.fields} /><br />
      </div>
    </div>
    <Field name="description" source="description" component={TextInput} label="Description" className={props.classes.fields} /><br /><br />

    <div style={{ width: '50%' }}>
      <Field name="visibilities" source="visibilities" component={SelectArrayInput} label="Visibility" choices={PropertyVisibilities} className={props.classes.fields} />
    </div><br /><br />

    <FieldArray name="options" baseName="options" component={KeyValueInput} containerWidth="70%" mainLabel="Options" addItemLabel="Add Ad Property Option" /><br /><br />

    * Zero Options - free form input<br />
    * One Option - display read-only text<br />
    * Multiple Options - dropdown selection
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Managed/Properties/Partials/SettingsTab.tsx